<template>
  <v-theme-provider
    :dark="currentTheme === 'dark'"
    :light="currentTheme === 'light'"
  >
    <div class="v-application--wrap">
      <div class="overflow-hidden">
        <header
          class="px-sm text-left shadow-sm v-sheet theme--light v-toolbar v-toolbar--absolute v-toolbar--flat v-toolbar--prominent v-app-bar"
          :style="{
            backgroundColor: platform?.colors?.appBar,
            borderColor: platform?.colors?.appBar,
          }"
          style="
            height: 200px;
            font-size: 1.5rem;

            margin-top: 0px;
            transform: translateY(0px);
            left: 0px;
            right: 0px;
            background-color: rgb(39, 39, 39);
            border-color: rgb(39, 39, 39);
          "
        >
          <div class="v-toolbar__content" style="height: 200px">
            <div class="container d-flex align-center mt-5">
              <img
                :src="platform?.logos?.light"
                height="45"
                class="ma-0 unselectable non-draggable"
                style="cursor: pointer"
              />
              <div class="spacer"></div>
              <div class="d-flex align-center gap-2">
                <v-btn :color="getColor('primary')" icon @click="toggleTheme">
                  <v-icon>mdi-theme-light-dark</v-icon>
                </v-btn>
                <v-btn :color="getColor('primary')"> Entrar </v-btn>
              </div>
            </div>
          </div>
        </header>
      </div>
      <main class="v-main" style="padding: 0px">
        <div class="v-main__wrap">
          <div
            class="container horizontal-container rounded-lg relative bg-transition"
            style="
              margin-top: 105px !important;
              background: transparent !important;
            "
          >
            <v-card class="rounded-xl header-size">
              <video-background
                style="z-index: 1"
                :src="platform?.logos?.videoCover || ''"
                class="header-size"
              >
                <div
                  class="d-flex flex-column justify-space-between py-8 px-12 rounded-xl header-size"
                >
                  <v-row no-gutters>
                    <v-col cols="12" sm="7" md="6" lg="5">
                      <div
                        class="d-flex flex-column justify-space-between align-center"
                      >
                        <div class="d-flex flex-column w-full">
                          <img
                            contain
                            width="100%"
                            style="max-width: 150px"
                            class="unselectable non-draggable"
                            :src="platform?.logos?.light"
                          />
                          <!-- <h6 class="white--text">
                      Organize eventos de forma simples e rápida
                    </h6> -->
                        </div>
                      </div>
                    </v-col>
                  </v-row>
                  <div
                    class="d-flex align-center w-full"
                    :class="{ 'flex-column': $vuetify.breakpoint.xsOnly }"
                    :style="{
                      gap: $vuetify.breakpoint.xsOnly ? '' : '0.5rem',
                    }"
                  >
                    <v-btn
                      :color="getColor('primary')"
                      large
                      :block="$vuetify.breakpoint.xsOnly"
                    >
                      Entrar
                    </v-btn>
                    <v-btn
                      text
                      color="white"
                      :block="$vuetify.breakpoint.xsOnly"
                    >
                      Eventos
                    </v-btn>
                    <v-spacer v-if="!$vuetify.breakpoint.xsOnly" />
                  </div>
                </div>
              </video-background>
            </v-card>
          </div>
          <div class="flex-grow-1"></div>
          <div class="mt-10">
            <footer
              class="v-footer font-weight-medium shadow-md -mt-20 v-sheet theme--light rounded-0 v-footer--inset"
              :style="{
                backgroundColor: platform?.colors?.footerBar,
                borderColor: platform?.colors?.footerBar,
              }"
              flat=""
              data-booted="true"
            >

              <div class="container">
                <v-row dense class="mt-20">
                  <v-col cols="12" md="4">
                    <h6 class="white--text mb-0">Sobre nós</h6>
                    <p class="body-2 grey--text text--lighten-2"></p>
                    <div class="align-center pb-2">
                      <p
                        class="grey--text font-weight-bold text-15 text--lighten-2 mb-0"
                      >
                        {{ platform?.name }}
                      </p>
                      <span class="grey--text text--lighten-2 text-12">
                        {{ platform?.legalInfo?.document }}
                      </span>
                    </div>
                  </v-col>
                  <v-col cols="12" md="4">
                    <h6 class="white--text">Explorar</h6>
                    <div class="mb-2">
                      <a class="grey--text text--lighten-2"> Home </a>
                    </div>
                    <div class="mb-2">
                      <a class="grey--text text--lighten-2"> Eventos </a>
                    </div>
                    <div class="mb-2">
                      <a class="grey--text text--lighten-2">
                        Termos &amp; Condições
                      </a>
                    </div>
                    <div class="mb-2">
                      <a class="grey--text text--lighten-2">
                        Politica de Privacidade
                      </a>
                    </div>
                  </v-col>
                  <v-col cols="12" md="4">
                    <div class="mb-5">
                      <h6 class="white--text mb-1">
                        Entre em contato com a gente!
                      </h6>
                      <div class="d-flex flex-wrap mb-2" style="gap: 0.5rem">
                        <a
                          :href="`mailto:${platform?.email}`"
                          target="_blank"
                          class="v-btn v-btn--is-elevated v-btn--has-bg theme--light v-size--small primary"
                          ><span class="v-btn__content"
                            ><i
                              aria-hidden="true"
                              class="v-icon notranslate v-icon--left mdi mdi-email theme--light"
                              style="font-size: 16px"
                            ></i>
                            Email
                          </span></a
                        ><button
                          target="_blank"
                          type="button"
                          class="v-btn v-btn--is-elevated v-btn--has-bg theme--light v-size--small primary"
                        >
                          <span class="v-btn__content"
                            ><i
                              aria-hidden="true"
                              class="v-icon notranslate v-icon--left mdi mdi-whatsapp theme--light"
                              style="font-size: 16px"
                            ></i>
                            Whatsapp
                          </span>
                        </button>
                      </div>
                    </div>
                    <div>
                      <h6 class="white--text mb-1">Nossas redes sociais!</h6>
                      <div class="d-flex flex-wrap mb-2" style="gap: 0.5rem">
                        <a
                          href="https://instagram.com/ticketme.app"
                          target="_blank"
                          class="v-btn v-btn--has-bg theme--light v-size--small primary"
                          ><span class="v-btn__content"
                            ><i
                              aria-hidden="true"
                              class="v-icon notranslate v-icon--left mdi mdi-instagram theme--light"
                              style="font-size: 16px"
                            ></i
                            ><span> @ticketme.app </span></span
                          ></a
                        >
                      </div>
                    </div>
                  </v-col>
                  <v-col cols="12" v-if="!platform?.hidePoweredBy">
                    <a
                      href="https://tiq.one"
                      class="d-flex gap-2 align-center"
                      target="_blank"
                    >
                      <small class="grey--text text--lighten-2">
                        PoweredBy
                      </small>
                      <img
                        style="height: 20px"
                        src="/img/logo/logo-dark.png"
                        alt=""
                      />
                    </a>
                  </v-col>
                </v-row>
              </div>
            </footer>
          </div>
        </div>
      </main>
    </div>
  </v-theme-provider>
</template>

<script>
import VideoBackground from "vue-responsive-video-background-player";

export default {
  name: "PlatformPreview",
  components: {
    VideoBackground,
  },
  props: {
    platform: {
      type: Object,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      currentTheme: this.$vuetify.theme.dark ? "dark" : "light",
    };
  },
  methods: {
    getColor(color, theme = this.currentTheme) {
      const scope = this.platform?.colors?.[theme];
      return scope?.[color] || this.$vuetify.theme.current.value;
    },
    toggleTheme() {
      this.$vuetify.theme.dark = !this.$vuetify.theme.dark;
    },
  },

  mounted() {
    this.$vuetify.theme.on("dark", () => {
      this.currentTheme = "dark";
    });
    this.$vuetify.theme.on("light", () => {
      this.currentTheme = "light";
    });
  },
};
</script>

<style scoped>
.header-size {
  height: 60vh !important;
  max-height: 400px !important;
}
.top-shadow {
  background: linear-gradient(175deg, black -5%, transparent 60%) !important;
}
</style>
